export default "__VITE_ASSET__BhJYT_Bl__"